import CloseIcon from '@mui/icons-material/Close';
import { Box, Dialog, DialogTitle, Divider, IconButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useState } from 'react';
import { SearchInput } from '@/shared/ui';
import type { SavedPresetRecord } from '../../model/types';
import { SavedPresetItem } from '../SavedPresetItem/SavedPresetItem';

const List = styled('ul')(() => ({
  listStyle: 'none',
  padding: 0,
  margin: 0,
  height: 300,
  overflowY: 'auto',
  minWidth: 420,
}));

interface Props {
  viewName: string;
  viewURL: string;
  savedPresets: SavedPresetRecord[];
  open: boolean;
  onItemClick?: (preset: SavedPresetRecord) => void;
  onClose: () => void;
}

export function SavedPresetsDialog({
  viewName,
  viewURL,
  savedPresets,
  open,
  onItemClick,
  onClose,
}: Props) {
  const [query, setQuery] = useState('');
  const filteredPresets = savedPresets.filter((preset) => {
    return preset.name.toLowerCase().includes(query.toLowerCase());
  });

  return (
    <Dialog
      PaperProps={{ sx: { borderRadius: 4 } }}
      open={open}
      onClose={onClose}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 2,
          justifyContent: 'space-between',
          fontSize: '1.5rem',
        }}
      >
        <span>{viewName} Presets</span>
        <IconButton size="small" onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Divider />
      <Box sx={{ p: 2 }}>
        <SearchInput query={query} onChange={setQuery} />
      </Box>
      <Divider />
      <List>
        {filteredPresets.length === 0 && (
          <Box sx={{ p: 2, color: '#817E7E', textAlign: 'center' }}>
            No presets found
          </Box>
        )}
        {filteredPresets.map((preset) => {
          return (
            <SavedPresetItem
              key={preset.id}
              presetRecord={preset}
              viewURL={viewURL}
              onClick={onItemClick}
            />
          );
        })}
      </List>
    </Dialog>
  );
}
